import type { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { BooleanAspect } from '@adornis/filter/aspect-schemas/BooleanAspect.js';
import { ProductLKK } from '@chancenwerk/shared/_cms/products/entities/ProductLKK.js';
import { KpfFilter } from '@chancenwerk/shared/filter/KpfFilter.js';
import '@chancenwerk/client/design/components/cr-flex.js';
import { ProductAspect } from '@chancenwerk/shared/master-data-management/kpf/entities/aspects/ProductAspect.js';
import { BehaviorSubject } from 'rxjs';

export const globalKpfFilter = new BehaviorSubject<KpfFilter>(
  new KpfFilter({
    aspects: [
      new BooleanAspect({ customID: 'active', value: true }),
      new ProductAspect({ fieldName: 'produkt._class', values: [ProductLKK._class] }),
    ],
  }),
);

globalKpfFilter.subscribe();

export const dirtyData = new BehaviorSubject<AdornisEntity[]>([]);
